import { FC } from 'react';
// Mui
import { Box, Typography } from '@mui/material';
// i18next
import { useTranslation } from 'react-i18next';

const PasswordHints:FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ pt: 2 }}>
      <Typography display="block" variant="caption" component="small">{t('form.helperText.passwordHint1')}</Typography>
      <Typography display="block" variant="caption" component="small">{t('form.helperText.passwordHint2')}</Typography>
      <Typography display="block" variant="caption" component="small">{t('form.helperText.passwordHint3')}</Typography>
      <Typography display="block" variant="caption" component="small">{t('form.helperText.passwordHint4')}</Typography>
    </Box>
  )
}

export default PasswordHints;
